import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface StatusMessageProps {
  disabled: boolean;
}

export const StatusMessage = ({ disabled = false }: StatusMessageProps) => {
  return (
    <div>
      <Typography
        variant="h5"
        weight="bold"
        color={disabled ? 'inactive' : 'active'}
      >
        You haven&apos;t saved a credit card.
      </Typography>

      <Typography color={disabled ? 'inactive' : 'active'}>
        Add a credit card for quick and easy checkout the next time you shop.
      </Typography>
    </div>
  );
};
